<template>
  <div class="container" v-if="!loading">
    <div class="bg-block">
      <div class="info">
        <div class="title">查看激活资料</div>
        <!-- <iframe
            src="https://devmobile.musicwow.com/#/appArticle?id=37"
            frameborder="0"
            style="width: 80%; height: 600px"
          ></iframe> -->
        <div v-html="mainData.content" class="content"></div>
      </div>
    </div>
  </div>
  <div
    class="container"
    v-else
    v-loading="loading"
    element-loading-text="加载中"
  ></div>
</template>

<script>
import {
  applyStatusApi,
  applyClickApi,
  applyDetailApi,
} from "@/api/storeWallet";

export default {
  name: "",
  data() {
    return {
      mainData: {},
      loading: true,
    };
  },
  created() {
    applyStatusApi().then((res) => {
      this.loading = true;
      if (res.error_code === 0) {
        this.loading = false;
        applyDetailApi({
          cate_id: 3,
        }).then((res) => {
          this.mainData = res.data.info;
          console.log(this.mainData);
          // 未开通的门店，都需要要进行点击数上报
          applyClickApi({
            article_id: res.data.info.id,
          }).then(() => {});
        });
      }
    });
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  height: 80vh;
  .bg-block {
    padding: 0 12px 12px 12px;
    background-color: #ffffff;
    border-radius: 4px;
    margin-bottom: 12px;

    .info {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 60px;
      .title {
        font-weight: 700;
        font-size: 18px;
        margin: 30px 0;
        color: #303133;
      }
      /deep/ .content {
        height: 70vh;
        border: 1px solid #c1c1c1;
        padding: 20px;
        overflow-y: auto;
        p {
          font-size: 16px !important;
        }
        a {
          border-bottom-color: none !important;
        }
        img {
          vertical-align: bottom;
        }
        ul {
          list-style-type: circle !important;
          li {
            list-style-type: circle !important;
          }
        }
        ol {
          list-style-type: decimal !important;
          li {
            list-style-type: decimal !important;
          }
        }
        &::-webkit-scrollbar {
          width: 4px;
          height: 8px;
        }
        &::-webkit-scrollbar-track {
          width: 4px;
          background: none;
        }
        &::-webkit-scrollbar-thumb {
          width: 4px;
          background: #c1c1c1;
          border-radius: 4px;
        }
      }
    }
  }
}
</style>
